// extracted by mini-css-extract-plugin
module.exports = {"availabilityItem":"AvailabilitySection_availabilityItem__2M0MT","availabilityItemProposal":"AvailabilitySection_availabilityItemProposal__10orz"};